// migrating from 1.5 to 1.6
angular.module('ng').config(['$locationProvider', function ($locationProvider) {
  $locationProvider.hashPrefix('');
  // if we go to angular 1.6
  // $compileProvider.preAssignBindingsEnabled(true);
}]);
